import { render, staticRenderFns } from "./channelComments.vue?vue&type=template&id=4886ce21&scoped=true&lang=pug&"
import script from "./channelComments.vue?vue&type=script&lang=js&"
export * from "./channelComments.vue?vue&type=script&lang=js&"
import style0 from "./channelComments.vue?vue&type=style&index=0&id=4886ce21&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4886ce21",
  null
  
)

export default component.exports